
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vizualni-prezentace",
      function () {
        return require("private-next-pages/vizualni-prezentace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vizualni-prezentace"])
      });
    }
  